import React, { useState } from "react";
import "./Enroll.css";
import { db } from "./firebase"; // make sure path is correct
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const EnrollForm = ({ program, onClose, onSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [occupation, setOccupation] = useState("");
  const [college, setCollege] = useState("");
  const [organization, setOrganization] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      program,
      name,
      email,
      occupation,
      collegeOrSchool: occupation === "student" ? college : "",
      organization: occupation === "employed" ? organization : "",
      timestamp: serverTimestamp()
    };

    try {
      await addDoc(collection(db, "enrollments"), formData);
      alert("Enrollment submitted successfully!");
      onSubmit(); // callback to parent
      setName("");
      setEmail("");
      setOccupation("");
      setCollege("");
      setOrganization("");
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Error submitting enrollment: " + error.message);
    }
  };

  return (
    <div className="enroll-modal-overlay">
      <div className="enroll-modal">
        <h2>Enroll in {program}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Full Name"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Your Email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
          />

          <select
            value={occupation}
            onChange={(e) => setOccupation(e.target.value)}
            required
          >
            <option value="">Select Occupation</option>
            <option value="student">Student</option>
            <option value="employed">Employed</option>
            <option value="other">Other</option>
          </select>

          {occupation === "student" && (
            <input
              type="text"
              placeholder="College/School/Institute Name"
              value={college}
              required
              onChange={(e) => setCollege(e.target.value)}
            />
          )}

          {occupation === "employed" && (
            <input
              type="text"
              placeholder="Organization/Company Name"
              value={organization}
              required
              onChange={(e) => setOrganization(e.target.value)}
            />
          )}

          <div className="form-actions">
            <button type="submit">Submit</button>
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EnrollForm;
